module.exports = __webpack_public_path__ + "static/media/Slide6.75152239.jpg";